import { DispatcherCustomerRegisterTemplate } from "../../Templates/DispatcherCustomerRegisterTemplate";

export const DispatcherCustomerRegister = () => {
  return <DispatcherCustomerRegisterTemplate />;
};
